import React from "react";

export const LazyTableExamplePage = React.lazy(
    () =>
        import(/* webpackChunkName: "TableExamplePage" */ "./TableExamplePage")
);

export const LazyInfiniteTableExamplePage = React.lazy(
    () =>
        import(
            /* webpackChunkName: "InfiniteTableExamplePage" */ "./InfiniteTableExamplePage"
        )
);
